/* API */
const Login = '/api/auth/jwt/login'
const SignUp = '/api/auth/register'
// const BaseInfo = '/api/v1/admin/user/base/info'
// const UserList = '/api/v1/admin/user'
// const Info = '/api/v1/admin/user/info'
const AllData = '/api/pension/get_pension_result/'
const Result = '/api/pension/get_result/'
const Result1 = '/api/pension/get_result1/'
const RetirementAge = '/api/pension/retirement_age/'
const SupportCities = '/api/pension/support_cities/'
const VerifyPassword = '/api/auth/verify_password'
const ResetPassword = '/api/users/me'
const InsureProductList = '/api/pension/insure_list/'
const InsureCashTableAdd = '/api/pension/insure_cash_table_add/'
export default {
  Login,
  SignUp,
  // BaseInfo,
  // UserList,
  // Info,
  AllData,
  Result,
  Result1,
  SupportCities,
  VerifyPassword,
  ResetPassword,
  InsureProductList,
  InsureCashTableAdd
}



// WEBPACK FOOTER //
// ./src/api/api.js